<template>
  <div class="main">
    <!-- banner -->
    <div class="ban" style="background-image: url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg');"></div>
    <!-- banner-end -->
    <!-- 内容 -->
    <div class="wp">
      <div class="g-top">
        <div class="tab">
          <ul>
            <li v-for="item in classIfyList" :key="item.id" :class="{ on: activeTab === item.id }">
              <a :href="'/product-center?catid=' + item.id" @click.prevent="setActiveTab(item.id)">
                {{ item.name }}
              </a>
            </li>
          </ul>
        </div>
        <div class="cur">
          当前位置：
          <a href="/">首页</a>&gt;
          <a href="#">应用中心</a>
        </div>
      </div>
    </div>
    <div class="wp is-pc">
      <el-row :gutter="5" >
        <el-col :span="5"  style="padding: 44px 0;">
          <el-menu @select="handleSelect" :default-active="defaultActive" class="el-menu-vertical-demo"
            background-color="#F7F7F7" text-color="#343232" active-text-color="#007DC7" :unique-opened="true">
            <div v-for="item in leftClassIfyList" :key="item.id">
              <el-submenu  v-if="item.children && item.children.length > 0" :index="item.id.toString()">
                <template slot="title">
                  <span>{{ item.name }}</span>
                </template>
                <!-- 递归渲染子菜单 -->
                <div v-for="child in item.children" :key="child.id">
                  <el-submenu v-if="child.children && child.children.length > 0"
                    :index="child.id.toString()">
                    <template slot="title">
                      <span>{{ child.name }}</span>
                    </template>
                    <el-menu-item v-for="subChild in child.children" :key="subChild.id"
                      :index="subChild.id.toString()">
                      {{ subChild.name }}
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item v-else :index="child.id.toString()">
                    <span>{{ child.name }}</span>
                  </el-menu-item>
                </div>
              </el-submenu>
              <el-menu-item v-else :index="item.id.toString()">
                <span>{{ item.name }}</span>
              </el-menu-item>
            </div>
          </el-menu>
        </el-col>
        <el-col :span="19">
            <div class="right-content">
                <div v-for="item in solutionInfoList" class="solution-item" :key="item.id">
                  <div class="solution-title">{{ item.solutionTitle }}</div>
                  <div class="solution-pdf" @click="downloadFile(item.solutionPdf)">产品规格书</div>

                </div>
                <div v-if="solutionInfoList.length === 0" class="solution-empty">暂无数据</div>
            </div>
       
        </el-col>
      </el-row>
    </div>

    <div class="wp is-mobile">
      <div class="mobile-menu" v-if="!isShowSolutionInfoList">
        <div class="mobile-menu-item" v-for="item in menuListByMobile" :key="item.id" @click="handleSelectByMobile(item)">{{ item.name }}</div>
      </div>
      <div class="mobile-content" v-if="isShowSolutionInfoList">
        <!-- <div class="back-button" @click="goBack">
          < 返回
        </div> -->
        <div class="right-content">
            <div v-for="item in solutionInfoList" class="solution-item" :key="item.id">
              <div class="solution-title">{{ item.solutionTitle }}</div>
              <div class="solution-pdf" @click="downloadFile(item.solutionPdf)">产品规格书</div>

            </div>
            <div v-if="solutionInfoList.length === 0" class="solution-empty">暂无数据</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import RequestUtil from '../utils/request';

export default {
  name: 'ProductCenter',
  data() {
    return {
      type: '',
      menuListByMobile: [
        { id: 18, name: '通信解决方案', children: [{ id: 181, name: '通信解决方案1' }] },
        { id: 19, name: '雷达解决方案', children: [{ id: 191, name: '雷达解决方案1' }] },
        { id: 20, name: '测试解决方案', children: [{ id: 201, name: '测试解决方案1' }] },
        { id: 21, name: '其他解决方案', children: [{ id: 211, name: '其他解决方案1' }] },
      ],
      isShowTable: true,
      classIfyList: [
        { id: 18, name: '通信解决方案' },
        { id: 19, name: '雷达解决方案' },
        { id: 20, name: '测试解决方案' },
        { id: 21, name: '其他解决方案' },
      ],
      activeTab: 18, // 默认显示波导器件
      defaultActive: '0',
      leftClassIfyList: [],
      solutionInfoList: [],
      isShowSolutionInfoList: false,
      // originalClassIfyList: [],
      // dataByJson: [],
      // infoList: [],
      // htmlText: '',
      // hasSearchField: false,
      // searchFields: [],
      // searchFilters: {},
      // filteredInfoList: [],
      // selectInfo: {},
      // applyInfo: {},

    }
  },
  methods: {
    handleSelectByMobile(item) {
        if (item.children && item.children.length > 0) {
          // 保存当前状态到历史记录
          this.$router.push({ 
            path: '/app-center', 
            query: { 
              id: item.id,
              type:'mobile'
            } 
          });
        } else {
          this.isShowSolutionInfoList = true;
          RequestUtil.get('/wx/solution/getSolutionInfoList?parentId=' + item.id).then(res => {
            this.solutionInfoList = res.data;
          })
        }
      // this.activeTab = item.id;
      // this.getAllClassIft();
    },
    getAllClassIft() {
      
      RequestUtil.get('/wx/solution/getAllSolutionClassIfy?parentId='+this.activeTab).then(res => {
        this.leftClassIfyList = res.data;
        try {
          let id = res.data[0].children[0].id;
          this.defaultActive = id.toString();
          this.handleSelect(id);
        } catch (error) {
          console.log(error);
        }
      })
    },

    handleSelect(index) {
        RequestUtil.get('/wx/solution/getSolutionInfoList?parentId='+index).then(res => {
        this.solutionInfoList = res.data;
      })
    },


    setActiveTab(tabId) {
      this.activeTab = parseInt(tabId);
      this.getAllClassIft();
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    downloadFile(url) {
      if (!url){
        alert('当前并未提供产品规格书');
        return;
      };
      url = "https://program.api.beijingxibao.com" + url
      //  window.open(url, '_blank', 'noopener,noreferrer');


         const route = this.$router.resolve({
  path: '/pdf-show',
  query: { type: "APP", url: url }
});
window.open(route.href, '_blank');
    },
    







  },

  created() {
        this.isShowSolutionInfoList = false;

    this.activeTab = parseInt(this.$route.query.id) || 18;
    this.getAllClassIft();
     RequestUtil.get('/wx/solution/getAllSolutionClassIfy?parentId='+this.activeTab).then(res => {
            this.menuListByMobile = res.data;
          })
    
  },
  
   watch: {
    // 监听路由变化
    '$route'(to, from) {
        const { id, type } = to.query;
    this.isShowSolutionInfoList = false;
    if (type === 'mobile') {
         RequestUtil.get('/wx/solution/getAllSolutionClassIfy?parentId='+id).then(res => {
            this.menuListByMobile = res.data;
          })
       }else{
          RequestUtil.get('/wx/solution/getAllSolutionClassIfy?parentId=0').then(res => {
            this.menuListByMobile = res.data;
          })
       }
         
    }
  }
}
</script>

<style>
@media screen and (min-width: 1200px) {
  .is-mobile {
    display: none;
  }
  .is-pc {
    display: block;
  }
  .right-content {
   display: flex;
   padding: 44px 0;
   flex-direction: column;
   gap: 15px;
  }
  .solution-item {
    display: flex;
    gap: 27px;
  }
  .solution-item div {
    background: #FAFAFA;
    flex: 1;
    text-align: center;
    padding: 14px 0;
  }
  .solution-title {

font-weight: 500;
font-size: 14px;
color: #333333;

  }
  .solution-pdf {
cursor: pointer;
font-weight: 500;
font-size: 14px;
color: #007DC7;

  }
  .solution-empty {
    text-align: center;
    color: #999999;
    font-size: 18px;
    line-height: 150px;
  }
  
}

/* 移动端适配 */
@media screen and (max-width: 1200px) {
  .ban, .is-pc {
    display: none;
  }
  .is-mobile {
    display: block;
  }

    .mobile-menu{
    margin-top: 4vw;
    display: flex;
    flex-wrap: wrap;
    gap: 3vw;
    justify-content: space-between;
  }
  .mobile-menu-item{
      width: calc(100% / 2 - 2vw);
      text-align: center;
      padding: 16px  0;
      background: #7D7777;
      border-radius: 7px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
  }
  .mobile-menu-item:hover{
      background-color: #037DC5;
  }

    .right-content {
   display: flex;
   padding: 44px 0;
   flex-direction: column;
   gap: 15px;
  }
  .solution-item {
    display: flex;
    gap: 27px;
  }
  .solution-item div {
    background: #FAFAFA;
    flex: 1;
    text-align: center;
    padding: 14px 0;
  }
  .solution-title {

font-weight: 500;
font-size: 14px;
color: #333333;

  }
  .solution-pdf {
cursor: pointer;
font-weight: 500;
font-size: 14px;
color: #007DC7;

  }
  .solution-empty {
    text-align: center;
    color: #999999;
    font-size: 18px;
    line-height: 150px;
  }
    html, body {
    background: #F5F6F7;
  }

}
</style>